import { render, staticRenderFns } from "./AgreeVerification.vue?vue&type=template&id=3fef8874"
import script from "./AgreeVerification.vue?vue&type=script&lang=js"
export * from "./AgreeVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports